import { TabType } from '@lib/types/common'
import classNames from 'classnames'

type Props = {
  children: React.ReactNode | React.ReactNode[]
  tabs: TabType[]
  activeTab: TabType
  setActiveTab: React.Dispatch<React.SetStateAction<TabType>>
  tabFontSize?: 'base' | 'lg'
}

const TabbedSection = ({
  children,
  tabs,
  activeTab,
  setActiveTab,
  tabFontSize = 'base',
}: Props) => (
  <>
    <div className="flex flex-col mb-4">
      <div className="flex border-b border-grey-500 space-x-10">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            type="button"
            onClick={() => setActiveTab(tab)}
            className={classNames('focus:outline-none capitalize pb-3 flex', {
              'text-orange font-600 border-b-2 border-orange':
                tab.value === activeTab.value,
              'text-grey hover:text-orange': tab.value !== activeTab.value,
              'text-base': tabFontSize === 'base',
              'text-lg': tabFontSize === 'lg',
            })}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <hr className="border-t border-grey-500 w-full -mt-px" />
    </div>
    <>{children}</>
  </>
)

export default TabbedSection
